import http from "src/common/http";
import { DEVELOPMENT_URL, ADMIN_LOGIN_URL, GET_ADMIN_DETAILS, UPLOAD_PROFILE_PICTURE, UPDATE_ADMIN_DETAILS } from "../constants/apiUrl";

const login = (email, password) => {
  return http
    .post(DEVELOPMENT_URL + ADMIN_LOGIN_URL, {
      email: email,
      password: password,
    })

};


const getUserDetail = () => {
  const user = window.sessionStorage.getItem("token");
  return http
    .get(DEVELOPMENT_URL + GET_ADMIN_DETAILS, {
      headers: {
        'authorization': `Bearer ${user}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
    .then((response) => {

      return response;
    })
};

const uploadProfilePicture = (formData) => {
  return http
    .post(DEVELOPMENT_URL + UPLOAD_PROFILE_PICTURE, formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        }
      },)

};


const updateUserDetail = (userDetails) => {
  const user = window.sessionStorage.getItem("token");
  return http
    .put(DEVELOPMENT_URL + UPDATE_ADMIN_DETAILS,userDetails, {
      headers: {
        'authorization': `Bearer ${user}`,
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      }
    })
  
};
export default { login, getUserDetail ,uploadProfilePicture, updateUserDetail};